import { render, staticRenderFns } from "./Detail-Warranty.vue?vue&type=template&id=f97a1de0"
import script from "./Detail-Warranty.vue?vue&type=script&lang=js"
export * from "./Detail-Warranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports